export function renderBoard(rack: TRackDef, board: TBoardState): TRenderedBoardState {
	const b = board.map((sq) => (sq !== "" && sq !== "#" ? rack.find((tile) => tile.id === sq)?.letter! : sq)); // TODO hack?? - ! operator

	return b;
}
